// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-element-heading {
  display: flex;
  flex-direction: column;
}

.form-element-heading.left {
  text-align: left;
}

.form-element-heading.center {
  text-align: center;
}

.form-element-heading.center * {
  margin: auto;
}

.form-element-heading.right {
  text-align: right;
}

.form-element-heading-title {
  font-weight: 700;
  color: var(--primary-color-a);
  display: flex;
  gap: 12px;
}

.form-element-heading-description {
  color: var(--neutral-color-a);
}

.form-element-heading-icon-container {
  display: flex;
}

.form-element-heading.center .form-element-heading-icon-container {
  justify-content: center;
}

.form-element-heading.right .form-element-heading-icon-container {
  flex-direction: row-reverse;
}

.form-element-heading-icon {
  width: 56px;
  height: 56px;
  line-height: 56px;
  text-align: center;
  margin-bottom: 24px !important;
  border-radius: 8px;
  font-size: 24px;
}

.form-element-heading-icon[data-icon='info'] {
  background-color: #95b5f855;
  color: var(--primary-color-a-5);
}

.form-element-heading-icon[data-icon='error'] {
  background-color: #d2000055;
  color: var(--semantic-error-color);
}

.form-element-heading-icon[data-icon='warning'] {
  background-color: #fa9a3c55;
  color: var(--semantic-warning-color);
}

.form-element-heading-icon[data-icon='sucess'] {
  background-color: #22b17055;
  color: var(--semantic-success-color);
}

.form-element-heading-icon[data-icon='locked'] {
  background-color: #d2000055;
  color: var(--semantic-error-color);
}

.form-element-heading-icon[data-icon='pending'] {
  background-color: #fa9a3c55;
  color: var(--semantic-warning-color);
}

.form-element-heading-success {
  display: inline-block;
  line-height: inherit;
  color: var(--semantic-success-color);
}`, "",{"version":3,"sources":["webpack://./src/components/form/heading/FormHeading.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,SAAS;AACX;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,oCAAoC;AACtC","sourcesContent":[".form-element-heading {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-element-heading.left {\n  text-align: left;\n}\n\n.form-element-heading.center {\n  text-align: center;\n}\n\n.form-element-heading.center * {\n  margin: auto;\n}\n\n.form-element-heading.right {\n  text-align: right;\n}\n\n.form-element-heading-title {\n  font-weight: 700;\n  color: var(--primary-color-a);\n  display: flex;\n  gap: 12px;\n}\n\n.form-element-heading-description {\n  color: var(--neutral-color-a);\n}\n\n.form-element-heading-icon-container {\n  display: flex;\n}\n\n.form-element-heading.center .form-element-heading-icon-container {\n  justify-content: center;\n}\n\n.form-element-heading.right .form-element-heading-icon-container {\n  flex-direction: row-reverse;\n}\n\n.form-element-heading-icon {\n  width: 56px;\n  height: 56px;\n  line-height: 56px;\n  text-align: center;\n  margin-bottom: 24px !important;\n  border-radius: 8px;\n  font-size: 24px;\n}\n\n.form-element-heading-icon[data-icon='info'] {\n  background-color: #95b5f855;\n  color: var(--primary-color-a-5);\n}\n\n.form-element-heading-icon[data-icon='error'] {\n  background-color: #d2000055;\n  color: var(--semantic-error-color);\n}\n\n.form-element-heading-icon[data-icon='warning'] {\n  background-color: #fa9a3c55;\n  color: var(--semantic-warning-color);\n}\n\n.form-element-heading-icon[data-icon='sucess'] {\n  background-color: #22b17055;\n  color: var(--semantic-success-color);\n}\n\n.form-element-heading-icon[data-icon='locked'] {\n  background-color: #d2000055;\n  color: var(--semantic-error-color);\n}\n\n.form-element-heading-icon[data-icon='pending'] {\n  background-color: #fa9a3c55;\n  color: var(--semantic-warning-color);\n}\n\n.form-element-heading-success {\n  display: inline-block;\n  line-height: inherit;\n  color: var(--semantic-success-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
